import { render, staticRenderFns } from "./tasima.vue?vue&type=template&id=6de3f3d9"
import script from "./tasima.vue?vue&type=script&lang=js"
export * from "./tasima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports